<template>
  <div style="background-color: #F8F9FB;">
    <hhead></hhead>
    <crm-nav :val="count"></crm-nav>

    <div class="jgMsg_box manager">
      <div
        class="jgMsg"
        :style="{
          minHeight: MHeight,
          boxSizing: 'border-box',
          minWidth: '1300px'
        }"
      >
        <!-- 添加 搜索 -->
        <div style="display: flex;height: 70px;" class="searchBox">
          <div
            @click="addBtn('1')"
            class="addBtn"
            style="width: 92px;margin-right: 20px;"
          >
            <i class="el-icon-plus"></i>添加
          </div>
          <el-button
            style="background:#5B85FF;color:#fff;height:34px;margin-top:15px;padding:0px 12px"
            class="iconfont icon-daorushuju"
            type="primary"
            @click="addExport()"
            ><i v-html="' '"></i> 导入初始化数据</el-button
          >

          <!-- <el-input style="width: 185px;" v-model="name" placeholder="请输入投资经理名称"></el-input>

                    <div style="display: flex;margin-top: 15px;margin-left: 20px;">
                        <input class="btn" @click="searchBtn" type="button" value="搜索" />
                        <input style="color: #fff;background-color: #5B85FF;" class="btn" type="reset" @click="resetBtn"
                            value="重置" />
          </div>-->
        </div>
        <!-- 添加 搜索 -->

        <el-tabs v-model="activeName" @tab-click="seeBtn">
          <el-tab-pane
            v-for="(item, index) in listRes"
            :key="item.id"
            :label="item.name"
            :name="item.name"
          >
            <div class="list_box">
              <div class="listItem">
                <div
                  class="topTitleBox"
                  :style="{ background: item.backgroundColor }"
                ></div>
                <div class="listBody">
                  <div class="jy">
                    <div
                      class="uploadBox"
                      :style="{
                        background: item.backgroundColor,
                        marginBottom: '15px'
                      }"
                    >
                      <div
                        style="background-color: #fff;border-radius: 50%;text-align: center;"
                        @click="uploadBtn_(item)"
                      >
                        <el-upload
                          style="height: 88px;"
                          class="avatar-uploader"
                          :action="'/api' + '/ad/upload/upload_file'"
                          :show-file-list="false"
                          name="file"
                          :data="{ id: item.id }"
                          accept="image/png, image/jpeg"
                          :on-success="handleAvatarSuccess_img"
                        >
                          <img
                            v-if="item.photoPath"
                            @click="uploadBtn_(item)"
                            style="width: 90px;height: 88px;border-radius: 50%;object-fit: cover;"
                            :src="'/api' + item.photoPath"
                            class="avatar"
                          />
                          <i
                            v-if="!item.photoPath"
                            @click="uploadBtn_(item)"
                            style="color: #dcdfe6;width: 88px;height: 88px;line-height: 88px;text-align: center;font-size: 44px;margin-left: 3px;"
                            class="iconfont icon-shangchuantouxiang"
                          ></i>
                        </el-upload>
                      </div>
                    </div>

                    <div class="jyMsg">
                      <div style="display: flex;">
                        <p
                          style="font-size: 20px;font-weight: 500;color: #0A101E;"
                        >
                          {{ item.name }}
                        </p>
                        <li class="liBox">
                          <span
                            style="margin-left:10px;"
                            @click="delBtn(item)"
                            class="iconfont icon-shanchu"
                          ></span>
                          <span @click="delBtn(item)" class="decoration1"
                            >删除</span
                          >
                        </li>
                      </div>

                      <li
                        class="liBox"
                        style="font-size: 16px;align-items: center;display: flex;"
                      >
                        <i
                          class="iconfont icon-xiugai"
                          @click="editBtn(item, '3')"
                          style="cursor: pointer;margin-top: 1px;font-size: 18px;margin-right: 3px;"
                        ></i>
                        <span
                          @click="editBtn(item, '3')"
                          class="decoration1"
                          style="cursor: pointer;line-height: 22px;"
                          >指定交易员</span
                        >
                      </li>

                      <ul class="userMsgBox">
                        <li v-for="(e, i) in item.memsList" :key="e.id">
                          <img
                            v-if="e.selfImage"
                            :src="'/api' + e.selfImage"
                            alt="加载失败"
                          />
                          <img
                            v-if="!e.selfImage"
                            src="../../../assets/images/crm/nan.png"
                            alt
                          />
                          <div>
                            <p>{{ e.memsName }}</p>
                            <span class="iconfont icon-shouji01">{{
                              e.memsPhone
                            }}</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <!-- <h3 style="margin-bottom: 0;" @click="editBtn(item,'4')"><span class="iconfont icon-xiugai" ></span>操作账户</h3>   -->

                  <li
                    class="liBox"
                    style="font-size: 16px;align-items: center;display: flex;color: #5B85FF;"
                  >
                    <i
                      class="iconfont icon-xiugai"
                      @click="editBtn(item, '4')"
                      style="cursor: pointer;font-size: 18px;margin-right: 3px;"
                    ></i>
                    <span
                      @click="editBtn(item, '4')"
                      class="decoration1"
                      style="cursor: pointer;line-height: 22px;"
                      >交易账户</span
                    >
                  </li>

                  <!-- 交易账户 -->
                  <div class="user-list">
                    <li
                      class="user-li"
                      v-for="(e, i) in tabArray[index]"
                      :key="i"
                    >
                      <p>账&emsp;&emsp;号：{{ e.userCode }}</p>
                      <p
                        style="white-space:nowrap;text-overflow: ellipsis;overflow: hidden;"
                      >
                        账户名称：{{ e.userName }}
                      </p>
                      <p>
                        账户类型：{{
                          e.accountType == "1"
                            ? "投顾账户"
                            : e.accountType == "2"
                            ? "模拟账户"
                            : e.accountType == "3"
                            ? "产品账户"
                            : e.accountType == "4"
                            ? "外部投顾账户"
                            : ""
                        }}
                      </p>
                      <p>交易倍率：{{ e.multiplyingPower }}</p>
                    </li>
                  </div>

                  <li
                    class="liBox"
                    style="font-size: 16px;align-items: center;display: flex;color: #5B85FF;justify-content: space-between;"
                  >
                    <!-- <i class="iconfont icon-xiugai" @click="editBtn(item,'4')" style="cursor: pointer;font-size: 18px;margin-right: 3px;"></i>
                    <span @click="editBtn(item,'4')" class="decoration1" style="cursor: pointer;line-height: 22px;">交易账户</span>-->

                    <p style="cursor: pointer;">
                      <i
                        style="font-size: 17px;"
                        @click="exportData"
                        class="iconfont icon-xiazai1"
                      ></i>
                      <span @click="exportData" class="decoration1"
                        >汇总数据</span
                      >
                    </p>

                    <p style="cursor: pointer;">
                      <i
                        @click="uploadBtn(item)"
                        style="font-size: 14px;"
                        class="iconfont icon-daorushuju"
                      ></i>
                      <span @click="uploadBtn(item)" class="decoration1"
                        >导入</span
                      >
                    </p>
                  </li>

                  <div class="table" style="margin-top: 10px;">
                    <el-table
                      :header-cell-style="{ background: '#F6F9FF' }"
                      :data="allData"
                      border
                      style="width: 100%"
                    >
                      <el-table-column
                        prop="userCode"
                        align="center"
                        label="账号"
                      ></el-table-column>
                      <!-- <el-table-column prop="tradingDay" align="center" label="交易日">
                      </el-table-column>-->
                      <el-table-column
                        prop="instrumentID"
                        align="center"
                        label="合约"
                      ></el-table-column>
                      <el-table-column align="center" label="买卖">
                        <template slot-scope="scope">
                          <span
                            :style="{
                              color:
                                scope.row.posiDirection == 50
                                  ? '#f00'
                                  : '#10c866'
                            }"
                            >{{
                              scope.row.posiDirection == 50 ? "买" : "卖"
                            }}</span
                          >
                        </template>
                      </el-table-column>

                      <el-table-column
                        prop="position"
                        align="center"
                        label="手数"
                      ></el-table-column>
                      <!-- <el-table-column prop="positionDay" align="center" label="当日手数">
                      </el-table-column>-->
                      <el-table-column
                        prop="averagePrice"
                        align="right"
                        label="开仓均价"
                      >
                        <template slot-scope="scope">
                          {{ scope.row.averagePrice | rbstateFormat }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="openCost"
                        align="right"
                        label="开仓成本"
                      >
                        <template slot-scope="scope">
                          {{ scope.row.openCost | rbstateFormat }}
                        </template>
                      </el-table-column>
                      <el-table-column width="60" align="center" label="操作">
                        <template slot-scope="scope">
                          <span
                            @click="dataDelBtn(scope.row)"
                            style="color: #3D6BF1;cursor: pointer;"
                            class="iconfont icon-shanchu decoration"
                          ></span>
                        </template>
                      </el-table-column>
                      <!-- <el-table-column prop="positionCost" align="center" label="持仓成本">
                      </el-table-column>-->
                    </el-table>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <!-- 浮层 -->
      <transition name="el-fade-in-linear">
        <div class="popContainer" v-if="isShow">
          <div
            v-loading="loading"
            element-loading-text="导入中"
            element-loading-spinner="el-icon-loading"
            class="add"
            :style="{ width: dialogWidth, paddingBottom: '20px' }"
          >
            <div class="close"></div>
            <div class="Top" :style="{ width: dialogWidth }">{{ title }}</div>
            <span
              v-if="!loading"
              @click="clearBtn"
              class="close iconfont icon-close_round_fill_bold"
            ></span>

            <!-- 添加 编辑 -->
            <div v-if="showType.add" class="formStyle">
              <el-form
                style="padding: 30px 60px 0 60px;"
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="120px"
                class="demo-ruleForm"
              >
                <el-form-item
                  v-if="type == '1' || type == '3'"
                  label="投资经理："
                  prop="name"
                >
                  <el-input
                    style="width:600px"
                    maxlength="20"
                    placeholder="请输入投资经理名称"
                    v-model="ruleForm.name"
                  ></el-input>
                </el-form-item>

                <el-form-item v-if="type == '1' || type == '3'">
                  <div slot="label">
                    <span style="color: #F56C6C;">*</span>&nbsp;持仓背景色：
                  </div>
                  <div style="margin-top: 9px;">
                    <!-- <span class="picker" :style="{display:'inline-block',width:'100px',height:'30px',background:color,marginRight:'10px'}"></span>
                                        <el-color-picker @active-change="activeChange"  v-model="color" size="small"
                                            :predefine="predefineColors">
    
                    </el-color-picker>-->

                    <div style="display: flex;">
                      <span
                        class="bgbgcolor"
                        v-for="(item, index) in colorList"
                        @click="clolrBtn(item)"
                        :style="{
                          padding: '1px',
                          width: '24px',
                          height: '24px',
                          cursor: 'pointer',
                          border:
                            color == item.color
                              ? '1px solid #5B85FF'
                              : '1px solid #E9ECF4',
                          marginRight: '24px',
                          borderRadius: '2px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }"
                        :key="index"
                      >
                        <i
                          :style="{
                            background: item.color,
                            width: '24px',
                            height: '24px'
                          }"
                        ></i>
                      </span>
                    </div>
                  </div>
                </el-form-item>

                <el-form-item
                  v-if="type == '1' || type == '3'"
                  label="指定交易员："
                >
                  <ul class="memberBox">
                    <li
                      :class="{ memberActive: item.checked == true }"
                      @click="memberClick(item)"
                      v-for="(item, index) in teamList"
                      :key="item.id"
                    >
                      <img
                        v-if="item.selfImage"
                        class="img"
                        :src="'/api' + item.selfImage"
                        alt
                      />
                      <img
                        v-if="!item.selfImage"
                        class="img"
                        src="../../../assets/images/crm/nan.png"
                        alt
                      />
                      <div
                        class="y_icon"
                        :style="{
                          position: 'absolute',
                          borderTop:
                            item.checked == true
                              ? '14px solid #5B85FF'
                              : '14px solid #B8CAFF',
                          borderRight:
                            item.checked == true
                              ? '14px solid #5B85FF'
                              : '14px solid #B8CAFF',
                          top: 0,
                          right: 0,
                          zIndex: 10,
                          borderLeft: '14px solid transparent',
                          borderBottom: '14px solid transparent'
                        }"
                      >
                        <span
                          style="position: absolute;z-index: 100;color: #fff;right: -12px;top: -26px;font-size: 12px;"
                          class="iconfont icon-duigou"
                        ></span>
                      </div>
                      <div>
                        <p>{{ item.name }}</p>
                        <span class="iconfont icon-shouji01">{{
                          item.phone
                        }}</span>
                      </div>
                    </li>
                  </ul>
                </el-form-item>

                <!-- <div
                  v-if="type == '4'"
                  class="itemTable table"
                  style="margin: 0;"
                 >
                  <el-table
                    :data="userList"
                    :header-cell-style="{ background: '#F6F9FF' }"
                    border
                    max-height="500px"
                    style="width: 100%"
                  >
                    <el-table-column
                      align="center"
                      width="100px"
                      :render-header="renderHeader"
                    >
                      <template slot-scope="scope">
                        <el-checkbox
                          @change="checkChange(scope, scope.$index)"
                          :value="scope.row.checked ? true : false"
                        ></el-checkbox>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="userCode"
                      align="center"
                      label="账号"
                    ></el-table-column>

                    <el-table-column
                      prop="userName"
                      align="center"
                      label="账户名称"
                    ></el-table-column>

                    <el-table-column
                      prop="simpleName"
                      align="center"
                      label="账户类型"
                    >
                      <template slot-scope="scope">
                        <div>
                          {{
                            scope.row.accountType == "1"
                              ? "投顾账户"
                              : scope.row.accountType == "2"
                              ? "模拟账户"
                              : scope.row.accountType == "3"
                              ? "产品账户"
                              : scope.row.accountType == "4"
                              ? "外部投顾账户"
                              : ""
                          }}
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column align="center" label="交易倍率">
                      <template slot-scope="scope">
                        <div class="inpDiv">
                          <el-input
                            :disabled="!scope.row.checked"
                            style="width: 66px;"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g, '$1').replace(/[^\d]/g,'')"
                            size="mini"
                            v-model="scope.row.multiplyingPower"
                          ></el-input>
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="userName"
                      align="center"
                      width="65"
                      label="优先级"
                    >
                      <template slot-scope="scope">
                        <div class="icon_sort" v-if="scope.row.checked">
                          <span
                            :style="{
                              color: scope.$index == 0 ? '#DCDFE6' : '#5b85ff'
                            }"
                            @click="upBtn(scope, scope.$index)"
                            class="iconfont icon-xiangshang4"
                          ></span>
                          <span
                            :style="{
                              color:
                                scope.$index == count_ - 1
                                  ? '#DCDFE6'
                                  : '#5b85ff'
                            }"
                            @click="downBtn(scope, scope.$index)"
                            class="iconfont icon-xiangxia4"
                          ></span>
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="userCode"
                      width="60"
                      align="center"
                      label="序号"
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.checked">{{
                          scope.$index + 1
                        }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div> -->
                <div v-if="type == '4'" style="display:flex;margin-bottom:10px">
                  <h3
                    style="width:53.3%;border-left:2px solid #5b85ff;padding-left:10px;height:16px;line-height:16px"
                  >
                    未选择账号
                  </h3>

                  <h3
                    style="width:40%;border-left:2px solid #5b85ff;padding-left:10px;height:16px;line-height:16px"
                  >
                    已选择账号
                  </h3>
                </div>
                <div
                  class="tableColor"
                  v-if="type == '4'"
                  style="display:flex;"
                >
                  <el-table
                    :data="userList"
                    row-key="id"
                    :header-cell-style="{ background: '#F6F9FF' }"
                    border
                    height="400px"
                    :row-class-name="style_none"
                    style="width: 40%"
                  >
                    <el-table-column
                      align="center"
                      width="50px"
                      :render-header="renderHeader"
                    >
                      <template slot-scope="scope">
                        <el-checkbox
                          @change="checkChange(scope, scope.$index)"
                          :value="scope.row.checked ? true : false"
                        ></el-checkbox>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="userCode"
                      align="center"
                      label="账号"
                    >
                    </el-table-column>

                    <el-table-column
                      prop="userName"
                      align="center"
                      label="账号名称"
                    >
                    </el-table-column>

                    <el-table-column align="center" label="交易倍率">
                      <template slot-scope="scope">
                        <div class="inpDiv">
                          <el-input
                            :disabled="!scope.row.checked"
                            style="width: 66px;"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g, '$1')"
                            size="mini"
                            v-model="scope.row.multiplyingPower"
                          ></el-input>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>

                  <div style="width:100px"></div>

                  <el-table
                    :row-class-name="style_block"
                    class="table_t"
                    :data="userList"
                    row-key="id"
                    :header-cell-style="{ background: '#F6F9FF' }"
                    border
                    height="400px"
                    style="width: 40%"
                  >
                    <el-table-column
                      align="center"
                      width="50px"
                      :render-header="renderHeader"
                    >
                      <template slot-scope="scope">
                        <el-checkbox
                          @change="checkChange(scope, scope.$index)"
                          :value="scope.row.checked ? true : false"
                        ></el-checkbox>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="userCode"
                      align="center"
                      label="账号"
                    >
                    </el-table-column>

                    <el-table-column
                      prop="userName"
                      align="center"
                      label="账号名称"
                    >
                    </el-table-column>

                    <el-table-column align="center" label="交易倍率">
                      <template slot-scope="scope">
                        <div class="inpDiv">
                          <el-input
                            :disabled="!scope.row.checked"
                            style="width: 66px;"
                            oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g, '$1')"
                            size="mini"
                            v-model="scope.row.multiplyingPower"
                          ></el-input>
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="userName"
                      align="center"
                      width="65"
                      label="优先级"
                    >
                      <template slot-scope="scope">
                        <div class="icon_sort" v-if="scope.row.checked">
                          <span
                            :style="{
                              color: scope.$index == 0 ? '#DCDFE6' : '#5b85ff'
                            }"
                            @click="upBtn(scope, scope.$index)"
                            class="iconfont icon-xiangshang4"
                          ></span>
                          <span
                            :style="{
                              color:
                                scope.$index == count_ - 1
                                  ? '#DCDFE6'
                                  : '#5b85ff'
                            }"
                            @click="downBtn(scope, scope.$index)"
                            class="iconfont icon-xiangxia4"
                          ></span>
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="userCode"
                      width="50"
                      align="center"
                      label="序号"
                    >
                      <template slot-scope="scope">
                        <span v-if="scope.row.checked">{{
                          scope.$index + 1
                        }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-form>
            </div>

            <div
              v-if="showType.add"
              class="form_btn"
              style="height: auto;margin-top: 30px;"
            >
              <button @click="submit('ruleForm')">确定</button>
            </div>
            <!-- 添加 编辑 -->

            <!-- 导入 -->
            <div
              class="form_box"
              style="width: auto;min-height: 190px;"
              v-if="showType.upload"
            >
              <div
                class="form"
                style="padding: 0px 30px 0px;min-height: 190px;"
              >
                <div class="col">
                  <div
                    style="text-align: right;
                            height: 27px;
                            line-height: 27px;
                            font-size: 16px;
                            padding-right: 15px;
                            margin-top:6px;
                            width:112px"
                  >
                    <span style="color:#F56C6C">*&nbsp;</span>附件上传
                  </div>
                  <div class="right" style="padding-right:55px">
                    <el-upload
                      ref="my-upload"
                      class="avatar-uploader"
                      :action="'/api' + '/ad/upload/upload_file'"
                      :on-remove="removeBtn"
                      name="file"
                      accept=".xlsx"
                      :limit="1"
                      :on-success="handleAvatarSuccess"
                    >
                      <i
                        style="color: #fff;width: 50px;height: 24px;background-color: #62DCB5;text-align: center;border-radius: 2px;display:inline-block;font-size: 14px;line-height: 24px;"
                        >上传</i
                      >
                      <span
                        style="font-size: 14px;color: #475173;margin-top: 7px;margin-bottom: 5px;display:inline-block;"
                      >
                        &emsp;&nbsp;请上传汇总数据，只能上传xlsx格式文件
                      </span>
                    </el-upload>
                    <div
                      style="font-size: 14px;color: #5B85FF;margin-top:5px;margin-left:-2px"
                    >
                      <a
                        download="导入汇总数据"
                        class="decoration2 iconfont icon-xiazai1"
                        target="_blank"
                        href="/api/template.xlsx"
                        style="color:#5b85ff;font-size:14px"
                        >&nbsp;导入汇总数据模板下载</a
                      >
                      <span style="color:#475173"
                        >&nbsp;&nbsp;请确保导入数据的正确性</span
                      >
                    </div>
                  </div>
                </div>
                <div class="form_btn" style="height: auto;">
                  <button @click="uploadSubmit">确定</button>
                </div>
              </div>
            </div>

            <!-- 导入 -->

            <!-- 查看 -->
            <div v-if="showType.see" style="padding: 0px 30px 0px;">
              <div class="table" style="margin-top: 20px;">
                <el-table
                  max-height="350px"
                  :data="allData"
                  border
                  style="width: 100%"
                >
                  <el-table-column
                    prop="userCode"
                    align="center"
                    label="账号"
                  ></el-table-column>
                  <el-table-column
                    prop="tradingDay"
                    align="center"
                    label="交易日"
                  ></el-table-column>
                  <el-table-column
                    prop="instrumentID"
                    align="center"
                    label="合约"
                  ></el-table-column>
                  <el-table-column
                    prop="multiplyingPower"
                    align="center"
                    label="买卖"
                  >
                    <template slot-scope="scope">
                      <span
                        :style="{
                          color:
                            scope.row.posiDirection == 50 ? '#f00' : '#10c866'
                        }"
                        >{{ scope.row.posiDirection == 50 ? "买" : "卖" }}</span
                      >
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="position"
                    align="center"
                    label="手数"
                  ></el-table-column>

                  <!-- <el-table-column prop="positionDay" align="center" label="当日手数">
                  </el-table-column>-->

                  <el-table-column
                    prop="averagePrice"
                    align="center"
                    label="开仓均价"
                  ></el-table-column>
                  <el-table-column
                    prop="openCost"
                    align="center"
                    label="开仓成本"
                  ></el-table-column>
                  <!-- <el-table-column prop="positionCost" align="center" label="持仓成本">
                  </el-table-column>-->
                </el-table>
              </div>
              <div class="form_btn" style="height: auto;margin-top: 40px;">
                <button @click="exportData">导出</button>
              </div>
            </div>
            <!-- 查看 -->

             <!-- 导入初始化数据 -->
          <div class="exportClass" v-if="showType.export">
            <el-form
              style="padding: 30px 60px 0 60px;"
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="95px"
              class="demo-ruleForm"
            >
              <!-- <el-form-item
                style="margin-bottom:0"
                label="模板："
                prop=""
              >
                
              </el-form-item> -->
              <el-form-item
                style="margin-bottom:0"
                label="附件上传："
                prop="name"
              >
                <el-upload
                  ref="my-upload"
                  class="avatar-uploader"
                  :action="'/api' + '/ad/upload/upload_file'"
                  :on-remove="removeBtn_1"
                  name="file"
                  accept=".xlsx"
                  :limit="1"
                  :on-success="handleAvatarSuccess_1"
                >
                  <i
                    style="color: #fff;width: 70px;height: 24px;background-color: #62DCB5;text-align: center;border-radius: 4px;display:inline-block;font-size: 14px;line-height: 24px;"
                    >上传文件</i
                  >
                </el-upload>
                <div
                  style="font-size: 14px;color: #5B85FF;margin-top:5px;margin-left:-2px;line-height:20px;transform:translateY(-5px);"
                >
                  <a
                  download="导入初始化数据"
                  class="decoration2 iconfont icon-xiazai1"
                  target="_blank"
                  href="/api/syncGroup.xlsx"
                  style="color:#5b85ff;font-size:14px"
                  >&nbsp;导入初始化数据模板下载</a
                >
                <span style="color:#475173"
                  >&nbsp;&nbsp;请确保导入数据的正确性</span
                >
                </div>
              </el-form-item>
              <el-form-item
                style="margin-bottom:0"
                v-if="tableShow"
                label="文件适配："
                prop=""
              >
                <div slot="label">
                  <i style="color:#F56C6C">*</i> 文件适配：
                </div>
                <div
                  class="grouping-divide table"
                  style="max-height:500px;overflow-y:auto"
                >
                  <table class="grouping_table" border="1">
                    <tr style="text-align:left">
                      <th>账户</th>
                      <th>合约</th>
                      <th>分组</th>
                      <th style="text-align:center">总持仓</th>
                      <th style="text-align:center">分配持仓</th>
                      <th style="text-align:center">买卖</th>
                      <th style="text-align:right">开仓均价</th>
                      <th style="text-align:right">开仓成本</th>
                    </tr>
                    <tbody v-for="(item, index) in tableData" :key="index">
                      <tr v-for="(e, i) in item.groupName" :key="i + 1000">
                        <!-- 账号 -->
                        <td v-if="i == 0" :rowspan="item.groupName.length">
                          {{ item.UserCode }}
                        </td>
                        <!-- 合约 -->
                        <td v-if="i == 0" :rowspan="item.groupName.length">
                          {{ item.InstrumentId }}
                        </td>
                        <!-- 分组 -->
                        <td>{{ e }}</td>
                        <!-- 总持仓 -->
                        <td
                          style="text-align:center"
                          v-if="i == 0"
                          :rowspan="item.groupName.length"
                        >
                          {{ item.Position }}
                        </td>
                        <!-- 分配持仓 -->
                        <td >
                          <!-- <el-input
                            v-model="item.positions[i]"
                            style="width:60px;margin-left:20px"
                            size="small"
                            placeholder=""
                          ></el-input> -->
                          <el-input-number 
                            class="el-input-number_style"
                            v-model="item.positions[i]" 
                            style="width:100px;" 
                            controls-position="right" 
                            @change="handleChange($event,index,i)" 
                            :min="0" 
                            :max="parseInt(item.Position)"
                          ></el-input-number>
                        </td>
                        <!-- 买卖 -->
                        <td
                          v-if="i == 0"
                          :style="{
                            color:
                              item.PosiDirectionText == '买'
                                ? '#FF2A2A'
                                : '#08AE47',
                            textAlign: 'center'
                          }"
                          :rowspan="item.groupName.length"
                        >
                          {{ item.PosiDirectionText }}
                        </td>
                        <!-- 开仓均价 -->
                        <td
                          style="text-align:right;"
                          v-if="i == 0"
                          :rowspan="item.groupName.length"
                        >
                          {{ item.AveragePrice | rbstateFormat }}
                        </td>
                        <!-- 开仓成本 -->
                        <td
                          style="text-align:right;"
                          v-if="i == 0"
                          :rowspan="item.groupName.length"
                        >
                          {{ item.OpenCost | rbstateFormat }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </el-form-item>
            </el-form>
            <div v-if="tableShow" class="form_btn" style="margin-top: 20px;">
              <button @click="submit_c()">保存</button>
            </div>
          </div>
          </div>
         
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import hhead from "../header/index";

import crmNav from "../../../components/crmNav/index";
import vuedraggable from "vuedraggable";
import Sortable from "sortablejs";
import "./style.css";

export default {
  components: { hhead, crmNav },
  data() {
    return {
      count_: 0,
      exportShow: false,
      theadData_1: [], //上传的表头
      tableShow:false,
      loading: false,
      dialogWidth: "870px",
      color: "",
      index: "",
      activeName: "",
      colorList: [
        { color: "#ff8080", index: 29 },
        { color: "#ff99cc", index: 45 },
        { color: "#ff9900", index: 52 },
        { color: "#ffcc99", index: 47 },
        { color: "#ffff99", index: 43 },
        { color: "#ffffcc", index: 26 },
        { color: "#33cccc", index: 49 },
        { color: "#ccffcc", index: 42 },
        { color: "#99ccff", index: 44 },
        { color: "#9999ff", index: 24 },
        { color: "#cc99ff", index: 46 },
        { color: "#ccccff", index: 31 }
      ],
      predefineColors: [
        "#FFC3C3",
        "#FFDDE7",
        "#FFDCF9",
        "#F7DDFF",
        "#FFD7C3",
        "#FFE6C3",
        "#FFF4B4",
        "#EFFAB4",
        "#D4FDC1",
        "#CBFDD7",
        "#C1FDE3",
        "#C6FFFE",
        "#C1F0FF",
        "#C7E3FF",
        "#d0deff",
        "#d0d8ff",
        "#CAD3FF",
        "#DAD6FF",
        "#d7ccff",
        "#e3d1ff"
      ],
      title: "",
      count: 8,
      id: "", //分组ID 编辑时赋值
      type: "1", //1 添加 2修改
      isShow: false, //添加 编辑
      showType: {
        add: false, //添加 编辑
        see: false, //查看
        upload: false, //导入
        export: false,
      },

      checkedAll: false,
      MHeight: document.documentElement.clientHeight - 94 + "px",
      tableData: [],
      ruleForm: {
        name: "",
        backgroundColor: "blue"
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }]
      },
      name: "", //分组名称
      listRes: [], //分组列表数据
      teamList: [], //团队成员
      userList: [], //交易账户
      tabArray: [], //表格分页数据
      allData: [], //查看汇总数据
      excelData: [], //excel导出数据
      theadData: [], //上传的表头
      managerId: "", //分组ID
      path: "" ,//文件路径
      path_1: "", //文件路径
    };
  },

  mounted() {
    this.list(1);
    let that = this;
  },
  methods: {
    addExport() {
      if (true) {//this.exportShow
        //导入初始化数据
        this.title = "导入初始化数据";
        this.isShow = true;
        this.dialogWidth = "1180px";
        this.showType.export = true;
      } else {
        this.$alert("分组已有数据，无法初始化数据", {
          confirmButtonText: "确定",
          type: "error",
          center: true
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    removeBtn_1() {
      this.path_1 = ""; //删除文件路径
      this.tableData = [];
      this.tableShow = false;
    },
    handleAvatarSuccess_1(res, file) {
      console.log(res);
      if (res.code == 200) {
        this.path_1 = res.data.filePath;

        this.$axios
          .post(
            //获取表头
            "/crm/acc/to_lead",
            {
              apiToken: this.$store.state.usermsg.apiToken,
              path: res.data.filePath
            }
          )
          .then(r => {
            console.log(r);
            if (r.data.code == 200) {
              this.theadData_1 = r.data.data;
              let userCodeSubScript = ""; //账号
              let DirectionSubScript = ""; //买卖
              let averagePriceSubScript = ""; //均价
              let InstrumentIDSubScript = ""; //合约
              let PositionSubScript = ""; //总持仓
              let OpenCostSubScript = ""; //开仓成本

              if (r.data.data) {
                r.data.data.forEach((item, index) => {
                  if (item == "账号" || item == "账户") {
                    userCodeSubScript = index;
                  } else if (item == "多仓") {
                    DirectionSubScript = index;
                  } else if (item == "开仓均价") {
                    averagePriceSubScript = index;
                  } else if (item == "合约") {
                    InstrumentIDSubScript = index;
                  } else if (item == "总持仓") {
                    PositionSubScript = index;
                  } else if (item == "开仓成本") {
                    OpenCostSubScript = index;
                  }
                });
              }

              this.$axios
                .post("/crm/grouping/addInitializeData", {
                  apiToken: this.$store.state.usermsg.apiToken,
                  path: this.path_1,
                  userCodeSubScript:
                    userCodeSubScript || userCodeSubScript === 0
                      ? userCodeSubScript
                      : -1,
                  DirectionSubScript:
                    DirectionSubScript || DirectionSubScript === 0
                      ? DirectionSubScript
                      : -1,
                  averagePriceSubScript:
                    averagePriceSubScript || averagePriceSubScript === 0
                      ? averagePriceSubScript
                      : -1,
                  InstrumentIDSubScript:
                    InstrumentIDSubScript || InstrumentIDSubScript === 0
                      ? InstrumentIDSubScript
                      : -1,
                  PositionSubScript:
                    PositionSubScript || PositionSubScript === 0
                      ? PositionSubScript
                      : -1,
                  OpenCostSubScript:
                    OpenCostSubScript || OpenCostSubScript === 0
                      ? OpenCostSubScript
                      : -1
                })
                .then(rep => {
                  console.log(rep);
                  if (rep.data.code == 200) {
                    this.tableShow = true;
                    rep.data.data.forEach(el=>{
                      if(el.positions.length > 0){
                        el.positions[0] = parseInt(el.Position)
                      }
                    })
                    this.tableData = rep.data.data;
                  } else {
                    this.$alert(rep.data.message, {
                      confirmButtonText: "确定",
                      type: "error",
                      center: true
                    })
                      .then(() => {})
                      .catch(() => {});
                  }
                });
            } else {
              this.$alert(r.data.message, {
                confirmButtonText: "确定",
                type: "error",
                center: true
              })
                .then(() => {})
                .catch(() => {});
            }
          });
      } else {
        this.$alert(res.data.message, {
          confirmButtonText: "确定",
          type: "error",
          center: true
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    handleChange(currentValue,index,i){
      if(this.tableData[index].groupName.length == 2){
        if(i==0){
          this.tableData[index].positions[1] = this.tableData[index].Position - currentValue
        }else{
          this.tableData[index].positions[0] = this.tableData[index].Position - currentValue
        }
      }
    },
    submit_c() {
      if (this.path_1) {
        //导入初始化数据提交.
        let groupIds = [];
        let userCodes = [];
        let direction = [];
        let averagePrice = [];
        let instrumentIDs = [];
        let positions = [];
        let positionsNum = 0;
        let positionsAll = 0;
        let openCost = [];
        let ProductId = [];
        let ExchangeId = [];
        let VolumeMultiple = [];

        this.tableData.forEach((item, index) => {
          item.positions.forEach((e, i) => {
            groupIds.push(item.groupId[i]);
            userCodes.push(item.UserCode);
            direction.push(item.PosiDirection);
            averagePrice.push(item.AveragePrice);
            instrumentIDs.push(item.InstrumentId);
            ProductId.push(item.ProductId);
            ExchangeId.push(item.ExchangeId);
            VolumeMultiple.push(item.VolumeMultiple);
            positions.push(e);
            positionsAll += e * 1;
            openCost.push(item.OpenCost);
          });
          positionsNum += item.Position * 1;

          console.log(
            groupIds,
            userCodes,
            direction,
            averagePrice,
            instrumentIDs,
            positions,
            positionsAll,
            "----",
            positionsNum
          );
        });

        if (positionsNum == positionsAll) {
          this.loading = true;

          this.$axios
            .post("/crm/grouping/saveGroupedPositionData", {
              apiToken: this.$store.state.usermsg.apiToken,
              groupIds: groupIds,
              userCodes: userCodes,
              direction: direction,
              averagePrice: averagePrice,
              instrumentIDs: instrumentIDs,
              positions: positions,
              openCost: openCost,
              ProductId: ProductId,
              ExchangeId: ExchangeId,
              VolumeMultiple: VolumeMultiple
            })
            .then(res => {
              console.log(res);
              this.loading = false;
              if (res.data.code == 200) {
                this.clearBtn();
                this.listOrSeeBtn();
                this.exportAxios();
              } else {
                this.$alert(res.data.message, {
                  confirmButtonText: "确定",
                  type: "error",
                  center: true
                })
                  .then(() => {})
                  .catch(() => {});
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          this.$alert("请合理分配持仓", {
            confirmButtonText: "确定",
            type: "error",
            center: true
          })
            .then(() => {})
            .catch(() => {});
        }
      } else {
        this.$alert("请上传文件", {
          confirmButtonText: "确定",
          type: "error",
          center: true
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    drop() {
      // 业务场景描述行拖拽
      const tbody = document.querySelector(".table_t tbody");
      const that = this;
      Sortable.create(tbody, {
        animation: 500, // 拖拽动画
        onEnd: function(evt) {
          console.log(evt);
          that.userList.splice(
            evt.newIndex,
            0,
            that.userList.splice(evt.oldIndex, 1)[0]
          );
        }
      });
    },
    style_none(row) {
      console.log(row.row.checked);
      if (row.row.checked) {
        return "styleNone";
      }
    },
    style_block(row) {
      if (!row.row.checked) {
        return "styleNone";
      }
    },
    list(type) {
      //列表 查询
      this.$axios
        .post(
          "/crm/grouping/queryGrouping",
          this.name
            ? {
                apiToken: this.$store.state.usermsg.apiToken,
                name: this.name
              }
            : { apiToken: this.$store.state.usermsg.apiToken }
        )
        .then(res => {
          console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            let arr = [];
            this.listRes = res.data.data;
            if (type) {
              this.activeName = res.data.data[0].name;
              this.seeBtn({ index: 0 });
            }
            this.listRes.forEach(item => {
              // arr.push(item.accList.slice(0, 5))
              arr.push(item.accList);
            });
            this.tabArray = arr;
            console.log(this.tabArray);
          }
        });
    },
    addBtn(type) {
      if (this.listRes.length >= 999) {
        this.$alert("投资经理数量到达上限", {
          confirmButtonText: "确定",
          type: "error",
          center: true
        })
          .then(() => {})
          .catch(() => {});
      } else {
        this.dialogWidth = "870px";
        this.queryMems();
        this.queryAll();

        this.type = type;
        this.title = "添加";
      }
    },
    clolrBtn(e) {
      console.log(e);
      this.color = e.color;
      this.index = e.index;
    },
    body(type) {
      //锁定滚动条
      var m = document.getElementsByTagName("body")[0];
      m.style.overflowY = type;
    },
    currentPage(page, i) {
      //分页
      this.tabArray.splice(
        i,
        1,
        this.listRes[i].accList.slice(page * 5 - 5, page * 5)
      );
    },
    queryMems() {
      //添加查询团队成员列表

      this.$axios
        .post("/crm/mem/queryMems", {
          apiToken: this.$store.state.usermsg.apiToken
        })
        .then(res => {
          console.log(res);
          if (res.data.code == 200) {
            this.teamList = res.data.data;
          }
        });
    },
    delBtn(e) {
      //删除
      this.$confirm(`您确定要删除投资经理“${e.name}”吗？`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(r => {
          this.$axios
            .post("/crm/grouping/delGrouping", {
              apiToken: this.$store.state.usermsg.apiToken,
              id: e.id
            })
            .then(res => {
              console.log(res);
              this.tokenInvalid(res);
              if (res.data.code == 200) {
                this.list(1);
              } else {
                this.$alert(res.data.message, {
                  confirmButtonText: "确定",
                  type: "error",
                  center: true
                })
                  .then(() => {})
                  .catch(() => {});
              }
            });
        })
        .catch(err => {});
    },
    uploadBtn(e) {
      //输入数据
      this.title = "导入汇总数据";
      this.dialogWidth = "600px";
      this.isShow = true;

      this.showType.upload = true;
      this.managerId = e.id;
      this.body("hidden");
    },
    dataDelBtn(e) {
      console.log(e);
      var color = e.posiDirection == 50 ? "#f00" : "#10c866";
      this.$confirm(
        `您确定要删除该数据吗？<br/><div style="text-align:left !important;margin-left:130px;">账号：${
          e.userCode
        }<br/>合约：${e.instrumentID}<br/>买卖：<span style="color:${color}">${
          e.posiDirection == 50 ? "买" : "卖"
        }</span><br/>持仓：${e.position}</div>`,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.$axios
            .post("/crm/grouping/delGroupingData", {
              apiToken: this.$store.state.usermsg.apiToken,
              groupingId: e.busiUnit,
              userCode: e.userCode,
              instrumentId: e.instrumentID,
              posiDirection: e.posiDirection,
              userID: e.userID,
              userType: e.userType,
              serverFlag: e.serverFlag
            })
            .then(res => {
              console.log(res);
              this.$axios
                .post("/crm/grouping/groupingSubmitDataTwo", {
                  apiToken: this.$store.state.usermsg.apiToken,
                  groupingId: e.busiUnit
                })
                .then(res => {
                  console.log(res);
                  this.tokenInvalid(res);
                  if (res.data.code == 200) {
                    // this.title = "查看汇总数据"
                    // this.isShow = true
                    // this.showType.see = true
                    this.allData = res.data.data;
                    // this.body('hidden')
                  } else {
                    this.$alert(res.data.message, {
                      confirmButtonText: "确定",
                      type: "error",
                      center: true
                    })
                      .then(() => {})
                      .catch(() => {});
                  }
                });
            })
            .catch(err => {});
        })
        .catch(() => {});
    },
    seeBtn(e) {
      //查看汇总数据
      console.log(e);

      this.$axios
        .post("/crm/grouping/groupingSubmitDataTwo", {
          apiToken: this.$store.state.usermsg.apiToken,
          groupingId: this.listRes[e.index].id
        })
        .then(res => {
          console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            // this.title = "查看汇总数据"
            // this.isShow = true
            // this.showType.see = true
            this.allData = res.data.data;
            // this.body('hidden')
          } else {
            this.$alert(res.data.message, {
              confirmButtonText: "确定",
              type: "error",
              center: true
            })
              .then(() => {})
              .catch(() => {});
          }
        });
    },
    editBtn(e, type) {
      //编辑
      // this.isShow = true
      console.log(e);
      this.dialogWidth =
        type == "1" || type == "3" ? "870px" : type == "4" ? "1300px" : "";
      this.id = e.id;
      this.type = type;
      this.showType.add = true;
      this.title = type == "4" ? "编辑—操作账户" : "编辑";
      console.log(e);
      this.$axios
        .post("/crm/grouping/returnEditGrouping", {
          apiToken: this.$store.state.usermsg.apiToken,
          id: e.id
        })
        .then(res => {
          console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.teamList = res.data.data[0].entMemsList;
            this.userList = res.data.data[0].entAccList;
            this.ruleForm.name = res.data.data[0].name;
            this.index = res.data.data[0].backgroundColorIndex;
            this.color = res.data.data[0].backgroundColor;

            this.isShow = true;
            this.body("hidden");

            setTimeout(() => {
              this.drop();
            }, 1000);
          } else {
          }
        });
    },
    uploadBtn_(e) {
      //上传时获取分组id
      console.log(e);
      this.managerId = e.id;
    },
    handleAvatarSuccess_img(res, file) {
      //图片导入
      if (res.code == 200) {
        console.log(res);
        this.$axios
          .post(
            //获取表头
            "/crm/grouping/photoPathGrouping",
            {
              apiToken: this.$store.state.usermsg.apiToken,
              path: res.data.filePath,
              groupingId: this.managerId
            }
          )
          .then(r => {
            console.log(r);
            this.list();
          });
      } else {
        this.$message.error(res.message);
      }
    },

    handleAvatarSuccess(res, file) {
      //导入excel

      console.log(res);
      this.tokenInvalid(res);
      if (res.code == 200) {
        this.path = res.data.filePath;
        this.$axios
          .post(
            //获取表头
            "/crm/acc/to_lead",
            {
              apiToken: this.$store.state.usermsg.apiToken,
              path: res.data.filePath
            }
          )
          .then(r => {
            console.log(r);
            if (r.data.code == 200) {
              this.theadData = r.data.data;
            } else {
              this.$alert(r.data.message, {
                confirmButtonText: "确定",
                type: "error",
                center: true
              })
                .then(() => {})
                .catch(() => {});
            }
          });
      } else {
        this.$alert(res.data.message, {
          confirmButtonText: "确定",
          type: "error",
          center: true
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    uploadSubmit() {
      //导入excel提交
      if (this.path) {
        //文件路径是否存在
        this.loading = true;
        let userCodeSubScript = "";
        let TradingDaySubScript = "";
        let DirectionSubScript = "";
        let averagePriceSubScript = "";
        let InstrumentIDSubScript = "";
        let PositionSubScript = "";
        let PositionDaySubScript = "";
        let OpenCostSubScript = "";
        let PositionCostSubScript = "";

        if (this.theadData) {
          this.theadData.forEach((item, index) => {
            console.log(item, index);
            if (item == "账户" || item == "账号") {
              userCodeSubScript = index;
            } else if (item == "交易日") {
              TradingDaySubScript = index;
            } else if (item == "买卖") {
              DirectionSubScript = index;
            } else if (item == "开仓均价") {
              averagePriceSubScript = index;
            } else if (item == "合约") {
              InstrumentIDSubScript = index;
            } else if (item == "手数") {
              PositionSubScript = index;
            }
            // else if(item == "当日手数"){
            //     PositionDaySubScript = index
            // }
            else if (item == "开仓成本") {
              OpenCostSubScript = index;
            }
            // else if(item == "持仓成本"){
            //     PositionCostSubScript = index
            // }
          });
        }
        console.log(
          userCodeSubScript,
          TradingDaySubScript,
          DirectionSubScript,
          averagePriceSubScript,
          InstrumentIDSubScript,
          PositionSubScript,
          OpenCostSubScript
        );
        this.$axios
          .post("/crm/grouping/addSubmitDataTwo", {
            apiToken: this.$store.state.usermsg.apiToken,
            path: this.path,
            groupingId: this.managerId, //分组id
            userCodeSubScript:
              userCodeSubScript || userCodeSubScript === 0
                ? userCodeSubScript
                : -1, //交易账户id
            TradingDaySubScript:
              TradingDaySubScript || TradingDaySubScript === 0
                ? TradingDaySubScript
                : -1, //交易日
            DirectionSubScript:
              DirectionSubScript || DirectionSubScript === 0
                ? DirectionSubScript
                : -1, //买卖
            averagePriceSubScript:
              averagePriceSubScript || averagePriceSubScript === 0
                ? averagePriceSubScript
                : -1, //均价
            InstrumentIDSubScript:
              InstrumentIDSubScript || InstrumentIDSubScript === 0
                ? InstrumentIDSubScript
                : -1, //合约
            PositionSubScript:
              PositionSubScript || PositionSubScript === 0
                ? PositionSubScript
                : -1, //总持仓
            // PositionDaySubScript:  PositionDaySubScript,//当日持仓
            OpenCostSubScript:
              OpenCostSubScript || OpenCostSubScript === 0
                ? OpenCostSubScript
                : -1 //开仓成本
            // PositionCostSubScript:PositionCostSubScript//持仓成本
          })
          .then(res => {
            console.log(res);
            this.loading = false;
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.$alert(res.data.message, {
                confirmButtonText: "确定",
                dangerouslyUseHTMLString: true,
                type: "success",
                center: true
              })
                .then(() => {
                  this.listRes.forEach((e, i) => {
                    console.log(e.name, this.activeName);
                    if (e.name == this.activeName) {
                      this.seeBtn({ index: i });
                    }
                  });
                  this.clearBtn();
                })
                .catch(() => {});
            } else {
              this.$alert(res.data.message, {
                confirmButtonText: "确定",
                dangerouslyUseHTMLString: true,
                type: "error",
                center: true
              })
                .then(() => {})
                .catch(() => {});
            }
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.loading = false;
        this.$alert("请选择导入文件", {
          confirmButtonText: "确定",
          type: "error",
          center: true
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    removeBtn() {
      //数据删除
      this.path = ""; //删除文件路径
    },
    queryAll() {
      this.$axios
        .post("/crm/acc/queryAllAcc", {
          apiToken: this.$store.state.usermsg.apiToken,
          size: 10000,
          accountType: 3
        })
        .then(res => {
          console.log(res);
          if (res.data.code == 200) {
            this.userList = res.data.data;
            this.isShow = true;
            this.showType.add = true;
            this.body("hidden");
          }
        });
    },
    searchBtn() {
      //搜索
      this.list();
    },
    resetBtn() {
      //重置
      this.name = "";
      this.list();
    },
    activeChange(e) {
      // this.color = e
    },
    checkChange(e, i) {
      e.row.checked = !e.row.checked;
      let arr1 = [];
      let arr2 = [];
      let num = 0;
      this.userList.forEach(item => {
        if (item.checked) {
          arr1.push(item);
          num++;
        } else {
          arr2.push(item);
        }
      });
      this.count_ = num;
      this.userList = arr1.concat(arr2);
    },
    upBtn(e, index) {
      //向上
      var arr = this.userList;
      var num = 0;
      arr.forEach(item => {
        if (item.checked) {
          num++;
        }
      });
      if (index > 0 && index < num) {
        var arr = this.userList;
        arr.splice(index - 1, 1, ...arr.splice(index, 1, arr[index - 1]));
      }
    },
    downBtn(e, index) {
      //向下

      var arr = this.userList;
      var num = 0;
      arr.forEach(item => {
        if (item.checked) {
          num++;
        }
      });

      if (index < num - 1) {
        arr.splice(index + 1, 1, ...arr.splice(index, 1, arr[index + 1]));
      }
    },

    clearBtn() {
      //清空
      if (this.showType.add) {
        this.$refs["ruleForm"].resetFields();
      }
      this.ruleForm.name = "";
      this.isShow = false;
      this.path = "";
      this.showType = {
        add: false, //添加 编辑
        seeShow: false, //查看
        uploadShow: false, //导入
        export: false
      };
      this.color = "";
      this.checkedAll = false;
      this.tableShow = false;
      this.path_1 = "";
      this.body("auto");
    },
    renderHeader(h, { column }) {
      //表头全选
      return h("span", [
        h("el-checkbox", {
          style: "display:inline-flex;",
          on: {
            change: this.select
          },
          props: {
            value: this.checkedAll
          }
        }),
        h("span", column.label)
      ]);
    },
    select(checked) {
      // 如果checked为true则是勾选了对应的表头
      this.checkedAll = !this.checkedAll;
      if (checked) {
        this.userList.map(item => {
          item.checked = true;
        });
      } else {
        this.userList.map(item => {
          item.checked = false;
        });
      }
      let num = 0;
      this.userList.forEach(item => {
        if (item.checked) {
          num++;
        }
      });
      this.count_ = num;
    },
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.color && this.index) {
            let memsId = []; //	交易员id
            let accId = []; //交易账户id
            let multiplyingPower = []; //倍率
            let flag = true;
            this.teamList.forEach(item => {
              if (item.checked) {
                memsId.push(item.id);
              }
            });

            this.userList.forEach(item => {
              if (item.checked) {
                accId.push(item.id);
                if (item.multiplyingPower && item.multiplyingPower >= 0) {
                  multiplyingPower.push(item.multiplyingPower);
                } else {
                  flag = false;
                  return;
                }
              }
            });

            if (flag) {
              this.$axios
                .post(
                  this.type == 1
                    ? "/crm/grouping/addGrouping"
                    : "/crm/grouping/editGrouping",
                  {
                    apiToken: this.$store.state.usermsg.apiToken,
                    name: this.ruleForm.name,
                    backgroundColor: this.color,
                    backgroundColorIndex: this.index,
                    memsId: memsId,
                    accId: accId,
                    multiplyingPower: multiplyingPower,
                    id: this.id ? this.id : ""
                  }
                )
                .then(res => {
                  console.log(res);
                  if (res.data.code == 200) {
                    this.activeName = this.ruleForm.name;
                    if (this.type == 1) {
                      this.list(1);
                    } else {
                      this.list();
                    }
                    this.clearBtn();
                  } else {
                    this.$alert(res.data.message, {
                      confirmButtonText: "确定",
                      type: "error",
                      center: true
                    })
                      .then(() => {})
                      .catch(() => {});
                  }
                });
            } else {
              this.$alert("交易倍率至少大于0", {
                confirmButtonText: "确定",
                type: "error",
                center: true
              })
                .then(() => {})
                .catch(() => {});
            }
          } else {
            this.$alert("请选择持仓背景色", {
              confirmButtonText: "确定",
              type: "error",
              center: true
            })
              .then(() => {})
              .catch(() => {});
          }
        } else {
        }
      });
    },
    memberClick(e) {
      console.log(e);
      e.checked = !e.checked;
    },
    exportData() {
      //导出按钮
      this.excelData = this.allData; //将你要导出的数组数据（historyList）赋值给excelDate
      this.export2Excel(); //调用export2Excel函数，填写表头（clomns里的type）和对应字段(historyList里的属性名)
    },
    //表格数据写入excel
    export2Excel() {
      var that = this;
      require.ensure([], () => {
        const {
          export_json_to_excel
        } = require("@/components/excel/Export2Excel");
        //这里使用绝对路径( @表示src文件夹 )，使用@/+存放export2Excel的路径【也可以写成相对于你当前"xxx.vue"文件的相对路径，例如我的页面放在assets文件夹同级下的views文件夹下的“home.vue”里，那这里路径也可以写成"../assets/excel/Export2Excel"】
        const tHeader = [
          "账号",
          "合约",
          "买卖",
          "手数",
          "开仓均价",
          "开仓成本"
        ]; // 导出的excel表头名信息
        const filterVal = [
          "userCode",

          "instrumentID",
          "posiDirectionText",
          "position",
          "averagePrice",
          "openCost"
        ]; // 导出的excel表头字段名，需要导出表格字段名
        const list = that.excelData;
        const data = that.formatJson(filterVal, list);

        export_json_to_excel(tHeader, data, "汇总数据"); // 导出的表格名称，根据需要自己命名
      });
    },
    //格式转换，直接复制即可,不需要修改什么
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/crm/manager/index.vue